import { resolvePlaybackCanStart, type PlaybackTransport } from "./playbackTransport";

/** React synthetic event와 native keyboard event가 공유하는 playback shortcut 최소 계약. */
interface PlaybackShortcutKeyEvent {
  code: string;
  key: string;
  shiftKey: boolean;
  metaKey: boolean;
  ctrlKey: boolean;
  altKey: boolean;
  repeat: boolean;
  defaultPrevented: boolean;
  preventDefault: () => void;
  stopPropagation: () => void;
}

/**
 * 활성 transport의 unmodified Space를 한 번만 소비한다. focus scope와 listener 위치는
 * 호출자가 소유하고, 이 함수는 basic/rich playback UI의 toggle 의미만 맞춘다.
 */
export function consumePlaybackToggleShortcut(
  event: PlaybackShortcutKeyEvent,
  transport: PlaybackTransport,
  disabled = false,
): boolean {
  if (
    disabled ||
    event.defaultPrevented ||
    (event.code !== "Space" && event.key !== " ") ||
    event.shiftKey ||
    event.metaKey ||
    event.ctrlKey ||
    event.altKey
  ) {
    return false;
  }

  const snapshot = transport.getSnapshot();
  if (!snapshot.playing && !resolvePlaybackCanStart(snapshot)) return false;

  event.preventDefault();
  event.stopPropagation();
  if (!event.repeat) transport.toggle();
  return true;
}
